module.exports = __webpack_public_path__ + "static/media/imgCard01.68da3455.png";